import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Btn, Input, Modal } from "@/components/ui-kit";
import { useAuth } from "@/context/AuthContext";
import { CameraView } from "@/components/scanner/CameraView";
import { ScanResult } from "@/components/scanner/ScanResult";
import { PackagePlus, Search } from "lucide-react";

export function ScannerSheet({ onClose }) {
  const navigate = useNavigate();
  const { can } = useAuth();
  const [result, setResult] = useState(null);
  const [err, setErr] = useState(null);
  const [manual, setManual] = useState("");
  const [busy, setBusy] = useState(false);
  const [round, setRound] = useState(0);

  const lookup = useCallback(async (code) => {
    setBusy(true); setErr(null);
    try {
      const { data } = await api.get("/jobs/lookup", { params: { code } });
      setResult(data);
    } catch (e) {
      setErr(apiError(e.response?.data?.detail));
      setRound((r) => r + 1);
    }
    setBusy(false);
  }, []);

  const rescan = () => { setResult(null); setErr(null); setManual(""); setRound((r) => r + 1); };

  return (
    <Modal open onClose={onClose} title={result ? "Scanned" : "Scan Label"}>
      {result ? <ScanResult result={result} onClose={onClose} onRescan={rescan} /> : (
        <div className="space-y-4" data-testid="scanner-sheet">
          <CameraView key={round} onCode={lookup} />
          <p className="text-center text-xs text-muted-foreground">Point the camera at a job label QR code or barcode.</p>
          {err && <div className="rounded-md border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-500" data-testid="scanner-lookup-error">{err}</div>}
          <form onSubmit={(e) => { e.preventDefault(); if (manual.trim()) lookup(manual.trim()); }} className="flex gap-2">
            <Input value={manual} onChange={(e) => setManual(e.target.value)} placeholder="Or type job #, serial or batch #" className="h-11 flex-1" data-testid="scanner-manual-input" />
            <Btn size="lg" type="submit" disabled={busy} data-testid="scanner-manual-submit"><Search size={16} /></Btn>
          </form>
          {can("job.create") && (
            <Btn size="lg" variant="outline" className="w-full" onClick={() => { onClose(); navigate("/inward?new=1"); }} data-testid="scanner-new-inward">
              <PackagePlus size={16} /> New inward job (no label)
            </Btn>
          )}
        </div>
      )}
    </Modal>
  );
}
